import { useEffect, useState } from "react";
import { useUser } from "../context/useUser";
import { apiFetch } from "../api/client";
import { getRoleLabelFi } from "../utils/roleLabels";

export default function HousingCompanySelector({ value = "", onChange = null, label = "Valitse taloyhtiö" }) {
  const { user } = useUser();
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    if (!user) return;

    async function fetchCompanies() {
      try {
        const data = await apiFetch(`/user/${user.id}/housing-companies`, {
          token: user.token,
        });
        setCompanies(data);
      } catch (err) {
        console.error(err);
      }
    }

    fetchCompanies();
  }, [user]);

  const handleSelectionChange = (nextValue) => {
    const [housing_company_id, role] = nextValue.split(":");

    const company = companies.find(
      c => String(c.housing_company_id) === housing_company_id && c.role === role
    ) || null;

    if (onChange) {
      onChange(nextValue, company);
    }
  };

  return (
    <div className="housing-company-selector">
      <p className="category-title">{label}</p>
      <div className="selector-row">
        <select
          className="selector-dropdown"
          value={value}
          onChange={(e) => handleSelectionChange(e.target.value)}
        >
          <option value="" disabled>Valitse taloyhtiö</option>
          {companies.map((c) => (
            <option
              key={`${c.housing_company_id}-${c.role}`}
              value={`${c.housing_company_id}:${c.role}`}
            >
              {c.company_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}